import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useContext, useState } from "react";

import { AddIcon } from "assets";
import { AddPolicyModal } from "./AddPolicyModal";
import { Button } from "@/components/ui/button";
import { CityContext } from "contexts/city-context-provider";
import { Policy } from "types";
import { PolicyTable } from "./PolicyTable";
import { defaultPolicy } from "../policies.const";
import { usePolicies } from "../hooks/use-policies";
import useToggle from "hooks/use-toggle";

export const PoliciesPanel = () => {
  const { currentCity } = useContext(CityContext);
  const [openConfirmDelete, setOpenConfirmDelete] = useToggle();
  const [openAddPolicyModal, setOpenAddPolicyModal] = useToggle(false);
  const [selectedPolicy, setSelectedPolicy] = useState<Policy>(defaultPolicy);
  const { handleDeletePolicy } = usePolicies();

  const editPolicy = (input: Policy) => {
    setSelectedPolicy(input);
    setOpenAddPolicyModal();
  };

  const closeAddPolicyModal = () => {
    setOpenAddPolicyModal();
    setSelectedPolicy(defaultPolicy);
  };
  const handleClickDelete = (input: Policy) => {
    setOpenConfirmDelete();
    setSelectedPolicy(input);
  };
  const handleCloseConfirmDelete = () => {
    setOpenConfirmDelete();
    setSelectedPolicy(defaultPolicy);
  };
  const handleRemovePolicy = async () => {
    if (!selectedPolicy.id) return;
    await handleDeletePolicy({ policyId: selectedPolicy.id });
    handleCloseConfirmDelete();
  };

  return (
    <>
      <div className="flex flex-col gap-y-2 h-auto">
        <div className="w-full bg-white h-auto mb-3 rounded-lg flex flex-col gap-y-2 px-7 pt-6">
          <div className="flex justify-end">
            {currentCity && (
              <Button
                onClick={setOpenAddPolicyModal}
                className="flex flex-row gap-x-1 p-2 bg-white shadow-md outline-hidden font-bold text-sm rounded-md text-black hover:bg-primary/5"
              >
                Ajouter une régulation
                <AddIcon className="h-5 w-5" fill="white" />
              </Button>
            )}
          </div>
          <PolicyTable selectPolicy={editPolicy} onDelete={handleClickDelete} />
        </div>
      </div>
      {openAddPolicyModal && currentCity && (
        <AddPolicyModal currentCity={currentCity} policyData={selectedPolicy} onClose={closeAddPolicyModal} />
      )}
      <AlertDialog open={openConfirmDelete}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Supprimer une régulation</AlertDialogTitle>
            <AlertDialogDescription>Êtes-vous sûr de vouloir supprimer cette régulation?</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={handleCloseConfirmDelete}>Annuler</AlertDialogCancel>
            <AlertDialogAction onClick={handleRemovePolicy}>Supprimer</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
